module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_short_front_vector.808a0502.svg";